const postcard_triangles_clrs = [
  {
    idx: 0,
    title: "81 Rue Lepic",
    clrs: ["#7EB497", "#63828B", "#E6E2D0"],
    num_clrs: 3,
  },

  {
    idx: 1,
    title: "Brenda's dress",
    clrs: ["#ED2842", "#518256", "#DDBE58"], // brenda dress
    num_clrs: 3,
  },

  {
    idx: 2,
    title: "Le Musset",
    clrs: ["#1D2C45", "#88B0CB", "#D6C7A4"], // restarant with flowers
    num_clrs: 3,
  },
  {
    idx: 3,
    title: "L'Etoile 1903 Cafe",
    clrs: ["#22281D", "#BDCED2", "#FDF9AA"],
    num_clrs: 3,
  },
  {
    idx: 4,
    title: "Avenue Hoche",
    clrs: ["#DEE5DE", "#1F2770", "#5E9E90"],
    num_clrs: 3,
  },
  {
    idx: 5,
    title: "Arc de Triomphe",
    clrs: ["#7F7560", "#413D34", "#E0D8B9"],
    num_clrs: 3,
  },
  {
    idx: 6,
    title: "Rodier",
    clrs: ["#FFFFDA", "#CBC5A3", "#2E22A0"],
    num_clrs: 3,
  },
  {
    idx: 7,
    title: "Charles de Gaulle–Étoile",
    clrs: ["#153224", "#0D053A", "#C5911C"],
    num_clrs: 3,
  },
  {
    idx: 8,
    title: "Prunier",
    clrs: ["#233633", "#447473", "#FFFCC1"],
    num_clrs: 3,
  },
];

export { postcard_triangles_clrs };
